import React from 'react'
import { Mail, Phone } from "lucide-react";
import { Row, Col } from 'react-bootstrap';

const Contact = () => {
    return (
        <Row id="contact" className="mb-20 justify-content-center" >
            <Col xxl={8} xl={8} lg={8} md={11} sm={11}>
                <h3 className='text-xl font-bold mb-3 text-center'>
                    <span className='text-main'>Get In Touch</span>
                </h3>
                <p className="font-mono text-jobs mt-1 mb-3 text-center">I’m always open to new opportunities—whether it's an exciting project, a collaboration, or just a chance to connect. Feel free to reach out, even if it’s just to say hi. I’ll do my best to get back to you!</p>
                <Row className="justify-content-center mb-5">
                <a href="mailto:natthidapm93@gmail.com" className="text-center px-2 mb-2">
                            <Mail size={20} /> <span>natthidapm93@gmail.com</span>
                        </a>
                    <a href="tel:+66988282439" className="text-center px-2">
                            <Phone size={20} /> <span>+66 98 828 2439</span>
                        </a>
                </Row>

                <Row className='justify-content-center d-flex'>
                    <Col className='hover-soak justify-content-center d-flex' xxl={4} >
                        <a href="/files/Natthida-Promma.pdf" download
                            className=" px-5 py-3 border text-main custom-rounded text-center" >
                            Download Resume
                        </a>
                    </Col>

                </Row>
            </Col>


        </Row>
    )
}
export default Contact